import { toArrayBuffer } from '../javascript-utils/binary-utils';
var workerCache = new Map();

function getWorker(workerSource) {
  var workerURL = workerCache.get(workerSource);

  if (!workerURL) {
    var blob = new Blob([workerSource], {
      type: 'application/javascript'
    });
    workerURL = URL.createObjectURL(blob);
    workerCache.set(workerSource, workerURL);
  }

  return new Worker(workerURL);
}

export default function parseWithWorker(workerSource, data, options) {
  var worker = getWorker(workerSource);
  options = removeNontransferableOptions(options);

  var parse = function parse(rawData, opts) {
    return new Promise(function (resolve, reject) {
      worker.onmessage = function (evt) {
        switch (evt.data.type) {
          case 'done':
            resolve(evt.data.result);
            worker.terminate();
            break;

          case 'error':
            reject(new Error(evt.data.message));
            break;

          default:
        }
      };

      var arraybuffer = toArrayBuffer(rawData);
      worker.postMessage({
        arraybuffer: arraybuffer,
        opts: opts
      }, [arraybuffer]);
    });
  };

  return data ? parse(data, options) : parse;
}

function removeNontransferableOptions(options) {
  options = Object.assign({}, options);

  if (options.log !== null) {
    delete options.log;
  }

  return options;
}
//# sourceMappingURL=parse-with-worker.js.map